// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { contactUsRequestToJson, getDataRequestToJson, getDataResponseFromJson, getDefaultLocationRequestToJson, getDefaultLocationResponseFromJson, getLocationsRequestToJson, getLocationsResponseFromJson, getNavigationDataRequestToJson, getNavigationDataResponseFromJson, getSalesInfoRequestToJson, getSalesInfoResponseFromJson, listElevatedLocationsRequestToJson, listElevatedLocationsResponseFromJson, listLocationsRequestToJson, listLocationsResponseFromJson, setDefaultLocationRequestToJson, shouldDisplayPamRequestToJson, shouldDisplayPamResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getData(request) {
    const raw = await fetchRpc('atlas.v1.Atlas/GetData', getDataRequestToJson(request));
    return getDataResponseFromJson(raw);
}
export function getData$(request, options) {
    return defer(() => getDataWithTransport$(getGlobalTransport(), request, options));
}
export function getDataWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Atlas/GetData', getDataRequestToJson(request), options)
        .pipe(map(resp => getDataResponseFromJson(resp)));
}
export async function getNavigationData(request) {
    const raw = await fetchRpc('atlas.v1.Atlas/GetNavigationData', getNavigationDataRequestToJson(request));
    return getNavigationDataResponseFromJson(raw);
}
export function getNavigationData$(request, options) {
    return defer(() => getNavigationDataWithTransport$(getGlobalTransport(), request, options));
}
export function getNavigationDataWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Atlas/GetNavigationData', getNavigationDataRequestToJson(request), options)
        .pipe(map(resp => getNavigationDataResponseFromJson(resp)));
}
export async function getSalesInfo(request) {
    const raw = await fetchRpc('atlas.v1.Atlas/GetSalesInfo', getSalesInfoRequestToJson(request));
    return getSalesInfoResponseFromJson(raw);
}
export function getSalesInfo$(request, options) {
    return defer(() => getSalesInfoWithTransport$(getGlobalTransport(), request, options));
}
export function getSalesInfoWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Atlas/GetSalesInfo', getSalesInfoRequestToJson(request), options)
        .pipe(map(resp => getSalesInfoResponseFromJson(resp)));
}
export async function getLocations(request) {
    const raw = await fetchRpc('atlas.v1.Atlas/GetLocations', getLocationsRequestToJson(request));
    return getLocationsResponseFromJson(raw);
}
export function getLocations$(request, options) {
    return defer(() => getLocationsWithTransport$(getGlobalTransport(), request, options));
}
export function getLocationsWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Atlas/GetLocations', getLocationsRequestToJson(request), options)
        .pipe(map(resp => getLocationsResponseFromJson(resp)));
}
export async function listElevatedLocations(request) {
    const raw = await fetchRpc('atlas.v1.Atlas/ListElevatedLocations', listElevatedLocationsRequestToJson(request));
    return listElevatedLocationsResponseFromJson(raw);
}
export function listElevatedLocations$(request, options) {
    return defer(() => listElevatedLocationsWithTransport$(getGlobalTransport(), request, options));
}
export function listElevatedLocationsWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Atlas/ListElevatedLocations', listElevatedLocationsRequestToJson(request), options)
        .pipe(map(resp => listElevatedLocationsResponseFromJson(resp)));
}
export async function listLocations(request) {
    const raw = await fetchRpc('atlas.v1.Atlas/ListLocations', listLocationsRequestToJson(request));
    return listLocationsResponseFromJson(raw);
}
export function listLocations$(request, options) {
    return defer(() => listLocationsWithTransport$(getGlobalTransport(), request, options));
}
export function listLocationsWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Atlas/ListLocations', listLocationsRequestToJson(request), options)
        .pipe(map(resp => listLocationsResponseFromJson(resp)));
}
export async function contactUs(request) {
    await fetchRpc('atlas.v1.Atlas/ContactUs', contactUsRequestToJson(request));
}
export function contactUs$(request, options) {
    return defer(() => contactUsWithTransport$(getGlobalTransport(), request, options));
}
export function contactUsWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Atlas/ContactUs', contactUsRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function setDefaultLocation(request) {
    await fetchRpc('atlas.v1.Atlas/SetDefaultLocation', setDefaultLocationRequestToJson(request));
}
export function setDefaultLocation$(request, options) {
    return defer(() => setDefaultLocationWithTransport$(getGlobalTransport(), request, options));
}
export function setDefaultLocationWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Atlas/SetDefaultLocation', setDefaultLocationRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getDefaultLocation(request) {
    const raw = await fetchRpc('atlas.v1.Atlas/GetDefaultLocation', getDefaultLocationRequestToJson(request));
    return getDefaultLocationResponseFromJson(raw);
}
export function getDefaultLocation$(request, options) {
    return defer(() => getDefaultLocationWithTransport$(getGlobalTransport(), request, options));
}
export function getDefaultLocationWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Atlas/GetDefaultLocation', getDefaultLocationRequestToJson(request), options)
        .pipe(map(resp => getDefaultLocationResponseFromJson(resp)));
}
export async function shouldDisplayPam(request) {
    const raw = await fetchRpc('atlas.v1.Atlas/ShouldDisplayPam', shouldDisplayPamRequestToJson(request));
    return shouldDisplayPamResponseFromJson(raw);
}
export function shouldDisplayPam$(request, options) {
    return defer(() => shouldDisplayPamWithTransport$(getGlobalTransport(), request, options));
}
export function shouldDisplayPamWithTransport$(transport, request, options) {
    return transport
        .post('atlas.v1.Atlas/ShouldDisplayPam', shouldDisplayPamRequestToJson(request), options)
        .pipe(map(resp => shouldDisplayPamResponseFromJson(resp)));
}
